

















































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { AuthService } from '@/services';
import { Logger } from '@/tools/Logger';
import { Utility } from '@/tools/Utility';

@Component({
  name: 'ResetPasswordForm',
})
export default class ResetPasswordForm extends Vue {
  @Prop({ required: true }) private resetPasswordToken!: string;

  protected instructionMessage = 'Enter your new password:';

  protected missingTokenMessage = 'Please use the password reset link sent to your email';

  protected applicationName = '';

  protected error = '';

  protected isSnackbarVisible = false;

  protected isSuccessAlertVisible = false;

  protected strings = {
    success: 'Password successfully reset! Redirecting to login...',
  };

  private readonly logger: Logger = new Logger({ context: 'ResetPasswordForm' });

  private authService = AuthService.getInstance();

  private form = {
    email: '',
    name: '',
    password: '',
    passwordConfirmation: '',
    valid: false,
    rules: {
      required: (value: string) => !!value || 'Required',
      counter: (value: string) => value.length >= 6 || 'Minimum 6 characters',
    },
  };

  private loading = false;

  private isSubmitted = false;

  public mounted() {
    this.init();
  }

  /**
   * When enter key pressed in reset password form: focus password input, or register.
   * @e KeyboardEvent
   */
  protected onKeyup(e: KeyboardEvent) {
    if (e.key !== 'Enter') {
      return;
    }
    if ((e.target as HTMLElement).id === 'passwordConfirmation'
            && !this.loading
            && !this.isSubmitted) {
      this.resetPassword();
      return;
    }
    (this.$refs.password as any).focus(); // eslint-disable-line @typescript-eslint/no-explicit-any
  }

  private async init() {
    const config = await Utility.fetchConfig();
    this.applicationName = config.portal.name;
  }

  /**
   * reset password and navigate to login.
   */
  private async resetPassword() {
    if (!this.form.valid) {
      return;
    }

    this.loading = true;
    try {
      await this.authService.resetPassword(
        this.resetPasswordToken,
        this.form.password,
        this.form.passwordConfirmation,
      );
      this.isSuccessAlertVisible = true;
      this.loading = false;
      this.isSubmitted = true;
      setTimeout(() => this.$router.push({ name: 'login' }), 3000);
    } catch (error) {
      this.logger.error(error);
      this.error = error?.response?.data?.message ?? error.message;
      this.isSnackbarVisible = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    }
  }
}
